import React from 'react'
import { Route, Switch } from 'react-router-dom'

// components
import PrivateRoute from './components/routing/PrivateRoute'
import TreatmentsPage from './pages/TreatmentsPage'

const Login = React.lazy(() => import('./pages/Login'))
const Logout = React.lazy(() => import('./pages/Logout'))
const ResetPassword = React.lazy(() => import('./pages/ResetPassword'))
const Admin = React.lazy(() => import('./pages/Admin'))
const VerifyAccount = React.lazy(() => import('./pages/VerifyAccount'))
const Profile = React.lazy(() => import('./pages/Profile'))
const Help = React.lazy(() => import('./pages/Help'))
const Home = React.lazy(() => import('./pages/Home'))
const ForgotPassword = React.lazy(() => import('./pages/ForgotPassword'))
const Signup = React.lazy(() => import('./pages/Signup'))
const PatientsPage = React.lazy(() => import('./pages/PatientsPage'))
const InsurancesPage = React.lazy(() => import('./pages/InsurancesPage'))

const Routes = () => {
  return (
    <Switch>
      {/* No Login required */}
      <Route path={'/login'} component={Login} />
      <Route path={'/signup'} component={Signup} />
      <Route path={'/verifyAccount'} component={VerifyAccount} />
      <Route path={'/forgotPassword'} component={ForgotPassword} />
      <Route path={'/resetPassword'} component={ResetPassword} />
      <Route path={'/logout'} component={Logout} />
      <Route path={'/help'} component={Help} />
      {/* Login required */}
      <PrivateRoute path={'/profile'} component={Profile} />
      <PrivateRoute path={'/patients'} component={PatientsPage} />
      <PrivateRoute path={'/treatments'} component={TreatmentsPage} />
      <PrivateRoute path={'/insurances'} component={InsurancesPage} />
      <PrivateRoute path={'/admin-panel'} component={Admin} />
      <Route path={'/'} component={Home} />
    </Switch>
  )
}

export default Routes
